import {UserNotification} from '../../core/api-services/notification.service';

export interface NotificationDescriptionLine {
  label: string | null;
  value: string;
}

export function notificationDescriptionLines(
  notification: Pick<UserNotification, 'description' | 'note'>,
): NotificationDescriptionLine[] {
  const description = notification.description || notification.note || '';

  return description
    .split(/\r?\n/)
    .map(line => line.trim())
    .filter(line => line !== '')
    .map(line => {
      const match = /^(Request|Responsible):\s*(.*)$/.exec(line);

      return match
        ? {label: match[1] + ':', value: match[2]}
        : {label: null, value: line};
    });
}